import { render, staticRenderFns } from "./CollectionGroupPerformance.vue?vue&type=template&id=13306696&scoped=true"
import script from "./CollectionGroupPerformance.vue?vue&type=script&lang=js"
export * from "./CollectionGroupPerformance.vue?vue&type=script&lang=js"
import style0 from "./CollectionGroupPerformance.vue?vue&type=style&index=0&id=13306696&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13306696",
  null
  
)

export default component.exports